// extracted by mini-css-extract-plugin
module.exports = {"content":"Layout-module--content--UBmeX","contentWithAnnouncementBar":"Layout-module--content--with-announcement-bar--1CXV1"};